import { FC, useRef } from 'react'

import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'
import { BenefitsHealthcareEnrollmentPlanFragment } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useMemo } from 'modules/core/hooks/useMemo'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { personalInformationStep } from './PersonalInformationStep'
import { planOverviewStep } from './PlanOverviewStep'
import { HealthcareEnrollmentData, PersonalInformationFormData } from './types'

interface IdentifierType {
  value: string
  label: string
}

interface Props {
  healthcarePlanData: BenefitsHealthcareEnrollmentPlanFragment
  identifierTypes: IdentifierType[]
  initialPersonalInformationData: PersonalInformationFormData

  onSubmit: (data: HealthcareEnrollmentData) => void
  onClose: () => void
}

const HealthcareEnrollmentWizard: FC<Props> = ({
  healthcarePlanData,
  initialPersonalInformationData: personalInformationData,
  identifierTypes,
  onSubmit,
  onClose,
}) => {
  useEffect(() => {
    track(trackingEvents.benefits.openHealthcareEnrollmentWizard)
  }, [])

  const steps: WizardStep<HealthcareEnrollmentData>[] = useMemo(
    () => [planOverviewStep(), personalInformationStep()],
    []
  )

  const initialWizardData: HealthcareEnrollmentData = useRef({
    identifierTypes,
    healthcarePlanData,
    personalInformationData,
  }).current

  return (
    <Wizard.Modal
      title={i18n.t('benefits.healthcare.enrollment_wizard.title')}
      steps={steps}
      initialData={initialWizardData}
      onSubmit={onSubmit}
      bottomSpacing
      onClose={onClose}
    />
  )
}

export default HealthcareEnrollmentWizard
